// extracted by mini-css-extract-plugin
module.exports = {"DoseListPage":"dose-list_DoseListPage__3wfqt","DoseItem":"dose-list_DoseItem__3I7sj","fade-in":"dose-list_fade-in__23m3R"};